import NotFound from "../../../../common/notFound/notFound";

function QueueNotFound() {
  return <NotFound text={"The queue not found!"} />;
}
export default QueueNotFound;
